<!--
  공유하기 모달 팝업
  - 호출 방법
    1. 컴포넌트 등록
    2. 아래 방식으로 호출
      this.$popup.openModal(this.$el, SampleModalComponent, {
        fullModal: false, // full-page 스타일인 경우 true
        title: '팝업 타이틀',
        header: true, // 헤더 사용 여부
        footer: false, // 푸터 사용 여부
        classes: ['additional_class']
      })
-->
<template>
  <mmp-modal
    v-bind="modalAttrs"
    :class="['share_modal', classes, {'no_header' : !header, 'no_footer' : !footer}, deviceType]"
    v-on="listeners"
  >

    <template
      v-slot:header
      v-if="header"
    >
      <div v-dompurify-html="title"/>
      <button type="button" class="btn_close" @click="$emit('close')">
        <span class="blind">팝업 닫기</span>
      </button>
    </template>

    <template v-slot:content>
      <div class="wrap_share_btn">
        <ul class="share_btn_list">
          <li v-if="shareKakaoActive">
            <button
              class="btn_share kakao"
              @click="share('kakao')"
            >카카오톡</button>
          </li>
          <li v-if="shareFacebookActive">
            <button
              class="btn_share facebook"
              @click="share('facebook')"
            >페이스북</button>
          </li>
          <li>
            <button v-clipboard:copy="shareCopyUrl" v-clipboard:success="toastCopySuccess" class="btn_share url">URL 복사</button>
          </li>
        </ul>
      </div>
    </template>

    <template
      v-slot:footer
      v-if="footer"
    >
      <div />
    </template>

  </mmp-modal>
</template>

<script>

import { isEmpty } from 'lodash'

export default {
  name: 'ShareModal',
  components: {

  },
  // mixins: [commonMixin],
  props: {
    // full-page modal 적용 여부
    fullModal: {
      type: Boolean,
      default: true
    },
    useDefaultHeader: {
      type: Boolean,
      default: false
    },
    useDefaultFooter: {
      type: Boolean,
      default: false
    },
    // 헤더 자체 노출 여부
    header: {
      type: Boolean,
      default: true
    },
    // 푸터 자체 노출 여부
    footer: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    classes: {
      type: Array,
      default: null,
      required: false
    },
    eventNm: {
      type: String,
      default: '',
      required: true
    },
    bltndMstrSno: {
      type: String,
      default: '',
      required: true
    },
    bltndSno: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
      isDesktop: true, // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
      shareUrl: '' // 공유하기 URL
    }
  },
  computed: {
    isValidParam () {
      return true
    },
    modalAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: this.useDefaultHeader,
        useDefaultFooter: this.useDefaultFooter,
        fullModal: this.fullModal,
        title: this.title
      }
    },
    // 현재 디바이스 명 (pc, mobile, tablet)
    deviceType () {
      return window.vue.getStore('homeInfo').state.deviceType
    },
    promoInfoStore () {
      return window.vue.getStore('promoInfo')
    },
    promoInfo () {
      return this.promoInfoStore.state.promoInfo
    },
    kakaoApiKey () {
      return this.promoInfoStore.state.promoInfo.kakaoCtfcKeyCntnt
    },
    fbApiKey () {
      return this.promoInfoStore.state.promoInfo.facbkCtfcKeyCntnt
    },
    fbVersion () {
      return 'v7.0'
    },
    shareKakaoActive () {
      return !isEmpty(this.promoInfoStore.state.promoInfo.kakaoCtfcKeyCntnt)
    },
    shareFacebookActive () {
      return !isEmpty(this.promoInfoStore.state.promoInfo.facbkCtfcKeyCntnt)
    },
    shareCopyUrl () {
      // return window.location.href

      return this.shareUrl
    }
  },
  async created () {
    // this.getEvtInfoList()
    if (!isEmpty(this.kakaoApiKey)) {
      let kakaoScriptUrl = '/static/kakao.js'
      await this.$loadScript(kakaoScriptUrl, 'Kakao', 2000, 10)

      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(this.kakaoApiKey)
      }
    }
  },
  beforeMount () {

  },
  mounted () {
    const url = window.location.href
    const index = url.indexOf('?')

    this.shareUrl = url.substring(0, index).replace('boardMstr', 'boardDetail') + '?bltndMstrSno=' + this.bltndMstrSno + '&bltndSno=' + this.bltndSno
    console.log('shareModal.mounted', this.shareUrl)
  },
  methods: {
    // 공유하기 버튼 클릭 이벤트
    share (tag) {
      console.log('tag:', tag)
      // NOTE: 공유하기 처리
      if (tag === 'kakao') {
        this.shareKakao()
      } else {
        this.shareFacebook()
      }
    },
    // 공유하기_카카오톡
    shareKakao () {
      // this.snsLinkOpen = false
      window.Kakao.Link.sendDefault({
        objectType: 'text',
        text: this.eventNm,
        link: {
          // mobileWebUrl: window.location.href
          mobileWebUrl: this.shareUrl
        }
      })
    },
    // 공유하기_페이스북
    shareFacebook () {
      // this.snsLinkOpen = false
      if (window.FB && window.FB.ui) {
        window.FB.ui({
          method: 'share',
          // href: window.location.href,
          href: this.shareUrl,
          quote: this.eventNm
        })
      } else {
        // var facebookCallUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href)
        var facebookCallUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl)
        var windowOptions = {
          width: 600,
          height: 400,
          scrollbars: 'no'
        }
        this.$utils.common.openWindowPopup(facebookCallUrl, {}, undefined, windowOptions, false)
      }
    },
    // 공유하기_링크복사
    toastCopySuccess (e) {
      this.$popup.toast('복사되었습니다.')
      // this.snsLinkOpen = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/modal/ShareModal.vue